var React = require('react/addons');
var cx = require('classnames');
var $ = require('jquery');
var moment = require('ofs/moment');
var Fluxxor = require('fluxxor');
var FluxMixin = Fluxxor.FluxMixin(React);

var DatePicker = require('ofs/components/datepicker/DatePicker');
var Icon = require('ofs/components/common/Icon');

var DateSelect = React.createClass({
  mixins: [
    FluxMixin
  ],

  showPicker: function() {
    var trigger = $(this.refs.input.getDOMNode());

    var yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    this.getFlux().actions.layers.addPopover(<DatePicker
      selectionType="single"
      trigger={trigger}
      onSelect={this.handleSelect}
      minimumDate={yesterday}
      value={this.props.value ? moment(this.props.value) : null} />);
  },

  handleSelect: function(value) {
    setTimeout(() => {
      this.props.onChange(value.isoDateFormat());
      this.getFlux().actions.layers.remove();
    }, 0);
  },

  render: function() {
    var {placeholder, value, ...props} = this.props;

    var displayValue = null;
    if (value) {
      displayValue = moment(value).longDateFormat();
    }

    var inputClasses = cx({
      'ofs-Input': true,
      'ofs-Input--date': true
    });

    return (
      <div className="ofs-Input__Wrapper">
        <input type="hidden" value={value} {...props} />
        <div onClick={this.showPicker} className={inputClasses} ref="input">
          {displayValue ?
            <span className="value">{displayValue}</span> :
            <span className="ofs-Input__Placeholder">{placeholder || 'Select a date'}</span>}
        </div>
        <div className="ofs-Input__Icon" onClick={this.showPicker}>
          <Icon glyph="calendar" size="small" />
        </div>
      </div>
    );
  }
});

module.exports = DateSelect;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/inputs/date-select.jsx
 **/